// Dashboard_page.js
import React, { useState, useEffect, useContext } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Dashboard_verticalside from './Dashboard_verticalside';
import FormsBottomNavbar from '../Post Module/FormsBottomNavbar';
import TopHeader from './TopHeader';
import SearchAppBar from './SearchAppBar';
import Dashboard_content from './Dashboard_content';

import { BASE_URL } from '../../Api/ApiUrls';
import { AuthContext } from '../../AuthContext/AuthContext';
import DashboardModal from "./DashboardModal";
import SellerActivityPopup from './Selleractivitypopup';

const Dashboard_page = () => {
  const { userId } = useContext(AuthContext);

  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const [notificationData, setNotificationData] = useState({
    unread_count_liked: 0,
    unread_count_chat: 0,
    unread_count_newprop: 0,
    notifications_liked: [],
    notifications_chat: [],
    notifications_newprop: [],
  });


  // ============================================================
  // SEARCH
  // ============================================================

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      const lowerQuery = query.toLowerCase().trim();

      if (lowerQuery.includes('rent')) {
        navigate('/rent-propertymap');
      } else if (lowerQuery.includes('lease')) {
        navigate('/lease-map');
      } else if (lowerQuery.includes('buy')) {
        navigate('/buy-map');
      } else if (lowerQuery.includes('service')) {
        navigate('/home-service');
      } else if (lowerQuery.includes('jvjd')) {
        navigate('/jvjd');
      } else if (
        lowerQuery.includes('bank auction') ||
        lowerQuery.includes('bank auctions') ||
        lowerQuery.includes('auction')
      ) {
        navigate('/postbank-card');
      } else {
        alert('No matching service found. Redirecting to dashboard.');
        navigate('/dashboard');
      }
    }
  };


  // ============================================================
  // MARK NOTIFICATION AS READ
  // ============================================================

  const markNotificationAsRead = async (notificationId) => {
    try {
      const response = await fetch(
        `${BASE_URL}/notifications/read/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            notification_id: notificationId,
          }),
        }
      );

      if (response.ok) {
        setNotificationData((prevData) => {
          if (!prevData) return prevData;

          const updatedData = { ...prevData };

          ['liked', 'general', 'chat'].forEach((type) => {
            const key = `notifications_${type}`;

            if (updatedData[key]) {
              updatedData[key] = updatedData[key].map(
                (notification) =>
                  notification.notification_id === notificationId
                    ? {
                        ...notification,
                        is_read: true,
                      }
                    : notification
              );
            }
          });

          if (
            updatedData.notifications_liked?.some(
              (n) =>
                n.notification_id === notificationId &&
                !n.is_read
            )
          ) {
            updatedData.unread_count_liked = Math.max(
              0,
              updatedData.unread_count_liked - 1
            );
          }

          if (
            updatedData.notifications_newprop?.some(
              (n) =>
                n.notification_id === notificationId &&
                !n.is_read
            )
          ) {
            updatedData.unread_count_newprop = Math.max(
              0,
              updatedData.unread_count_newprop - 1
            );
          }

          if (
            updatedData.notifications_chat?.some(
              (n) =>
                n.notification_id === notificationId &&
                !n.is_read
            )
          ) {
            updatedData.unread_count_chat = Math.max(
              0,
              updatedData.unread_count_chat - 1
            );
          }

          return updatedData;
        });
      }
    } catch (error) {
      console.error(
        'Error marking notification as read:',
        error
      );
    }
  };


  // ============================================================
  // NOTIFICATION CLICK
  // ============================================================

  const handleNotificationClick = async (notification) => {
    const {
      notification_id,
      notification_type,
      property_id,
      property_type,
      user_id,
    } = notification;

    try {
      await markNotificationAsRead(notification_id);

      // ------------------------------
      // LIKED
      // ------------------------------

      if (notification_type === 'Liked') {
        if (property_id) {
          navigate(`/wishlist-users/${property_id}`);
        }

        return;
      }


      // ------------------------------
      // CHAT
      // ------------------------------

      if (notification_type === 'Chat') {
        if (property_id && user_id) {
          navigate(`/chat/${property_id}/${user_id}`);
        }

        return;
      }


      // ------------------------------
      // GENERAL
      // ------------------------------

      if (notification_type === 'general') {
        if (!property_id || !property_type) {
          console.warn('Missing property data');
          return;
        }

        if (property_type === 'sell') {
          navigate(`/buy-map/${property_id}`);
        } else if (property_type === 'lease') {
          navigate(`/lease-description/${property_id}`);
        } else if (property_type === 'rent') {
          navigate(`/rent-description/${property_id}`);
        } else if (property_type === 'best-deal') {
          navigate(`/hot-property-description/${property_id}`);
        } else {
          console.warn(
            'Unhandled property_type:',
            property_type
          );
        }

        return;
      }
    } catch (error) {
      console.error(
        'Notification click error:',
        error
      );
    }
  };


  // ============================================================
  // FETCH NOTIFICATIONS
  // ============================================================

  useEffect(() => {
    if (!userId) return;

    const fetchNotifications = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/notifications/unread/${userId}/`
        );

        const data = await response.json();

        setNotificationData(data);
      } catch (error) {
        console.error(
          'Error fetching notifications:',
          error
        );
      }
    };

    fetchNotifications();

    const interval = setInterval(
      fetchNotifications,
      30000
    );

    return () => clearInterval(interval);
  }, [userId]);


  // ============================================================
  // PAGE LAYOUT
  // ============================================================

  return (

     <>
    {/* <DashboardModal /> */}
     <SellerActivityPopup />
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        minHeight: '100vh',

        display: 'flex',
        flexDirection: 'column',

        backgroundColor: '#FBF6EC',

        overflow: 'hidden',
      }}
    >

      {/* ======================================================
          ROW 1 — TOP HEADER
          FULL WIDTH
          ====================================================== */}

      <Box
        sx={{
          width: '100%',
          height: '44px',
          minHeight: '44px',

          flexShrink: 0,
        }}
      >
        <TopHeader />
      </Box>


      {/* ======================================================
          ROW 2 — SIDEBAR + MAIN CONTENT
          ====================================================== */}

      <Box
        sx={{
          width: '100%',
          height: 'calc(100vh - 44px)',
          minHeight: 0,

          display: 'flex',

          flex: 1,

          overflow: 'hidden',
        }}
      >

        {/* ====================================================
            LEFT — VERTICAL SIDEBAR
            ==================================================== */}

        <Box
          sx={{
            width: '60px',
            minWidth: '60px',

            height: '100%',

            flexShrink: 0,

            overflow: 'hidden',
          }}
        >
          <Dashboard_verticalside />
        </Box>


        {/* ====================================================
            RIGHT — MAIN DASHBOARD
            ==================================================== */}

        <Box
          sx={{
            flex: 1,

            width: 'calc(100% - 60px)',

            minWidth: 0,
            minHeight: 0,

            height: '100%',

            display: 'flex',
            flexDirection: 'column',

            overflow: 'hidden',
          }}
        >

          {/* ================================================
              SEARCH BAR
              ================================================ */}

          <Box
            sx={{
              width: '100%',
              flexShrink: 0,
            }}
          >
            <SearchAppBar
              query={query}
              setQuery={setQuery}
              handleKeyPress={handleKeyPress}
              notificationData={notificationData}
              handleNotificationClick={
                handleNotificationClick
              }
            />
          </Box>


          {/* ================================================
              DASHBOARD CONTENT
              ================================================ */}

          <Box
            sx={{
              flex: 1,

              minHeight: 0,

              overflowY: 'auto',
              overflowX: 'hidden',

              mt: '8px',
            }}
          >
            <Dashboard_content />
          </Box>

        </Box>

      </Box>


      {/* ======================================================
          BOTTOM NAVIGATION
          ====================================================== */}

      <FormsBottomNavbar />

    </Box>
    </>
  );
};

export default Dashboard_page;